import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import { Button, Modal, Steps, Spin, Icon } from "antd";

import { setAccount, setChain, setBalance } from "../actions/app";
import { t } from "../utils/i18n";
import { enquireScreen } from "enquire-js";

const { Step } = Steps;

let isMobile;

enquireScreen((b) => {
  isMobile = b;
  console.log("isMobile", isMobile);
});

class StepModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      content: "",
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  getStep0 = () => {
    const { step, stepError } = this.props;
    if (stepError && step === 0) {
      return (
        <>
        <span>{t("approve")}</span>
          <span className="step-error">{t("failed")}</span>
        </>
      );
    } else if (step === 0) {
      return (
        <>
          <span>{t("approve")}</span>
          <Icon type="loading" style={{ fontSize: 20, color:"#1890ff",marginLeft:"6px" }} spin />
        </>
      );
    } else {
      return t("approve");
    }
  };
  getStep1 = () => {
    const { step, stepError } = this.props;
    if (stepError && step === 1) {
      return (
        <>
          <span>{t("confirm_listing")}</span>
          <span className="step-error">{t("failed")}</span>
        </>
      );
    } else if (step === 1) {
      return (
        <>
          <span>{t("confirm_listing")}</span>
          <Icon type="loading" style={{ fontSize: 20, color:"#1890ff",marginLeft:"6px" }} spin />
        </>
      );
    } else {
      return t("confirm_listing");
    }
  };

  render() {
    const { visible, step, stepError, handleRetryClick, handleCancel } =
      this.props;

    return (
      <div className="m-auto text-center">
        <Modal
          visible={visible}
          closeIcon={<i className="iconfont icon-guanbi"></i>}
          maskClosable={false}
          centered={isMobile ? false : true}
          onCancel={handleCancel}
          footer={null}
          wrapClassName={
            " message_modal_sell message_modal_step"
          }
        >
          <div className="h-full w-full" style={{ overflow: "scroll" }}>
            <div className="m-2 sell-title">
              <strong>{t("listing")}</strong>
            </div>
            <Steps direction="vertical" size="small" current={step}>
              <Step title={this.getStep0()} description={t("approve_des")} />
              <Step title={this.getStep1()} description={t("confirm_des")} />
            </Steps>
            {stepError && (
              <div>
                <Button onClick={handleRetryClick} className="retry-btn">
                  {t("retry")}
                </Button>
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentAccount: state.app.currentAccount,
  };
}

const mapDispatchToProps = {
  setAccount,
  setChain,
  setBalance,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(StepModal));
